module.exports = __webpack_public_path__ + "static/media/platform_img3.29bf35b1.jpg";